<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.equipment.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/equipment"><span>{{$t('tlt.equipment')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/equipment/edit"><span>{{$t('tlt.equipment.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('equipment')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('equipment')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.code')}}:</label>
                                <input class="form-control form-control-sm" v-model="code" type="text">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.name')}}:</label>
                                <input class="form-control form-control-sm" v-model="name" type="text">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.equipment.type')}}:</label>
                                <select class="form-control form-control-sm" 
                                :disabled="typeDisabled"
                                @click.native.stop @change="disableHierarchy" v-model="type">
                                        <!-- <option value="-1">{{ $t("lbl.basic.select.one") }}</option>                         -->
                                        <option value="T">{{ $t("lbl.equipment.type.tripperCar") }}</option>
                                        <option value="R">{{ $t("lbl.equipment.type.reclaimer") }}</option>
                                        <option value="S">{{ $t("lbl.equipment.type.stackerReclaimer") }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.equipment.mode')}}:</label>
                                <input class="form-control form-control-sm" v-model="mode" type="text">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.equipment.spec')}}:</label>
                                <input class="form-control form-control-sm" v-model="spec" type="text">
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.area')}}:</label>
                                <select class="form-control form-control-sm" v-model="area">
                                        <option>C1</option>
                                        <option>C2</option>
                                        <option>C3</option>
                                        <option>C4</option>
                                        <option>B1</option>
                                        <option>B2</option>
                                        <option>B3</option>
                                        <option>B4</option>
                                        <option>B5</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.equipment.manu')}}:</label>
                                <input class="form-control form-control-sm" v-model="manu" type="text">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.active')}}:</label>
                                <select class="form-control form-control-sm" v-model="active">
                                    <option value="true">{{ $t("lbl.basic.yes") }}</option>
                                    <option value="false">{{ $t("lbl.basic.no") }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.status')}}:</label>
                                <select class="form-control form-control-sm" v-model="status">
                                    <option value="r">{{ $t("lbl.equipment.status.running") }}</option>
                                    <option value="f">{{ $t("lbl.equipment.status.malfunction") }}</option>
                                    <option value="e">{{ $t("lbl.equipment.status.examineAndRepair") }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.equipment.faultTime')}}:</label>
                                <input class="form-control form-control-sm" type="date" v-model="faultTime">
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="form-group col-md-3">
                                <label class="control-label">{{$t('lbl.equipment.site')}}:</label>
                                <select class="form-control form-control-sm" v-model="site"
                                :disabled="siteDisabled"
                                @click.native.stop @change="selectParentLocal('S')">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in siteCBO" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label">{{$t('lbl.basic.area')}}:</label>
                                <select class="form-control form-control-sm" v-model="area"
                                :disabled="areaDisabled"
                                @click.native.stop @change="selectParentLocal('A')">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in areaCBO" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label">{{$t('lbl.equipment.workCenter')}}:</label>
                                <select class="form-control form-control-sm" 
                                :disabled="workCenterDisabled"
                                v-model="workCenter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in workCenterCBO" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                </select>
                            </div>
                        </div> -->
                    </div>
                </div>
            </form>
        </section>
    </div>
 </template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState } from "vuex";
import {fields}  from "@/model/master/Equipment";

const { mapFields } = createHelpers({
  getterType: 'equipment/getField',
  mutationType: 'equipment/updateField',
});
export default {
  data () {
    return {
      enterpriseDisabled: true,
      siteDisabled: true,
      areaDisabled: true,
      workCenterDisabled: true,
      typeDisabled: true
    }
  },
  computed: {
    ...mapFields(fields),
    ...mapState({
        enterpriseCBO: state => state.equipment.enterpriseCBO,
        siteCBO: state => state.equipment.siteCBO,
        areaCBO: state => state.equipment.areaCBO,
        workCenterCBO: state => state.equipment.workCenterCBO
    })
  },
  mounted(){
     this.typeDisabled = (this.$store.state.equipment.crudState == 'edit');
      if( !this.typeDisabled){
          this.disableHierarchy();
      }
  },
  methods: {
    ...mapActions("equipment", ["loadEquipmentByType", "selectParentLocal"]),
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
    disableHierarchy(){
        this.enterpriseDisabled= true;
        this.siteDisabled = true;
        this.areaDisabled =  true;
        this.workCenterDisabled =  true;

        this.$store.commit("equipment/setWorkCenterCBO", []);
        this.$store.commit("equipment/setEnterpriseCBO", []);
        this.$store.commit("equipment/setAreaCBO", []);
        this.$store.commit("equipment/setEnterpriseCBO", []);

        var enty1 = JSON.parse(JSON.stringify(this.$store.state.equipment.entity));
        enty1.enterprise = "";
        enty1.site = "";
        enty1.area = "";
        enty1.workCenter = "";

        this.$store.commit("equipment/setEntity", enty1);

        switch (this.$store.state.equipment.entity.locType) {
            case 'S':
                this.enterpriseDisabled= false;
            break;
            case 'A':
                this.enterpriseDisabled= false;
                this.siteDisabled = false;
            break;
            case 'W':
                this.enterpriseDisabled= false;
                this.siteDisabled = false;
                this.areaDisabled =  false;    
            break;
        }
        this.$store.dispatch('equipment/loadEquipmentByType', {type: 'S', idLoc : 1} );
    }
  }
};
</script>